import { useLazyQuery } from "@apollo/client";
import { Box } from "@mui/material";
import { FETCH_TAG_LIST_QUERY } from "@platformx/authoring-apis";
import { ContentTypeTagName, getCategoryTags } from "@platformx/content";
import { CommonBoxWithNumber, ShowToastError, XTags } from "@platformx/utilities";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useCustomStyle } from "../../CreateEvent.styles";
import { TagsProp } from "../../CreateEvent.types";

const EventChooseTags = ({
  state,
  setState,
  eventWholeRef,
  content = {},
  isEdit = false,
  unsavedChanges,
  setScrollToView,
  socialShareExpanded,
}: TagsProp) => {
  const { t } = useTranslation();
  const classes = useCustomStyle();

  const { currentContent = {} } = content;
  const [runFetchTagList] = useLazyQuery(FETCH_TAG_LIST_QUERY);
  const [tagData, setTagData] = useState([]);
  const [tagArr, setTagArr] = useState<string[]>([]);
  const [tagCategory, setTagCategory] = useState<any>([]);

  const handleTagOnChange = (event: any, category = "") => {
    let tagsArray: any = [...tagArr];
    let tagsCategory: any = [...tagCategory];
    if (event.target.checked && tagsArray?.length > 14) {
      event.target.checked = false;
      ShowToastError(t("allowed_tags_toast"));
    } else {
      if (event.target.checked) {
        tagsArray = [...tagArr, event.target.value];
        tagsCategory = [...tagsCategory, `${category}/${event.target.value}`];
      } else {
        tagsArray.splice(tagArr.indexOf(event.target.value), 1);
        tagsCategory.splice(tagsCategory.indexOf(`${category}/${event.target.value}`), 1);
      }
      setTagArr(tagsArray);
      setTagCategory(tagsCategory);

      setState({
        ...state,
        tags: tagsArray,
        tagsSocialShare: tagsArray,
        tag_sm: tagsCategory,
      });
      eventWholeRef.current = {
        ...eventWholeRef.current,
        tags: tagsArray,
        tagsSocialShare: tagsArray,
        tag_sm: tagsCategory,
      };
      unsavedChanges.current = true;
    }
  };

  useEffect(() => {
    if (Object.keys(tagData).length === 0) {
      runFetchTagList({
        variables: { start: 0, rows: 1000 },
      })
        .then((res) => {
          if (res?.data?.authoring_getTagsList) {
            setTagData(res?.data?.authoring_getTagsList ?? []);
            socialShareExpanded && setScrollToView("socialShare");
          }
        })
        .catch(() => {
          setTagData([]);
        });
    }
  }, []);

  useEffect(() => {
    if (Object.keys(currentContent).length > 0) {
      setTagArr(currentContent?.PageTags);
      setTagCategory(currentContent?.tag_sm);
    }
  }, [currentContent]);

  useEffect(() => {
    if (isEdit && state?.tags?.length) {
      setTagArr(state?.tags);
      setTagCategory(state?.tag_sm);
    }
  }, [state?.tags?.length]);

  useEffect(() => {
    if (!isEdit && state?.tags?.length === 0 && tagData?.length > 0) {
      handleTagOnChange({
        target: {
          checked: true,
          value: "Events",
        },
      });
    }
  }, [tagData?.length > 0]);
  useEffect(() => {
    const tagsCategory = getCategoryTags(tagData, tagArr);
    setTagCategory(tagsCategory);
    setState({
      ...state,
      tag_sm: tagsCategory,
    });
    eventWholeRef.current = {
      ...eventWholeRef.current,
      tag_sm: tagsCategory,
    };
  }, [tagData, tagArr]);
  return (
    <Box id='tags' className={`${classes.chooseTagsWp}`}>
      <CommonBoxWithNumber
        number='04'
        title={t("choose_tags")}
        titleVarient='h5bold'
        subTitleVarient='p4regular'
        subTitle={t("subhead")}>
        <Box className='noSpacWp'>
          <XTags
            isEdit={isEdit}
            tagData={tagData}
            selectedTag={tagArr}
            subCategory={ContentTypeTagName.events}
            handleTagOnChange={handleTagOnChange}
          />
        </Box>
      </CommonBoxWithNumber>
    </Box>
  );
};
export default React.memo(EventChooseTags);
